export const APP_ACTION_TYPE = {
	NONE: 'none',
	EXTERNAL_URL: 'externalUrl',
	FEATURED_ITEM: 'featuredItem',
	MENU_ITEM: 'menuItem'
} as const;
export type TAppActionType = typeof APP_ACTION_TYPE[keyof typeof APP_ACTION_TYPE];
